import '../../../../styles/knowledge-concept/ai-content/AIContent.css';

import { MathJax, MathJaxContext } from 'better-react-mathjax'; // Import MathJax
import React, { useEffect, useRef, useState } from 'react';
import {
	getAIContentData,
	getLatestAIContentId,
	saveAIContent,
} from '../../../../services/DashboardApi';

import ChatGPTLoader from './ChatGPTLoader';
import ImagePreviewModal from './ImagePreviewModal';
import fileAttachmant from '../../../../assets/file_attachment.svg';
import fileIcon from '../../../../assets/file-icon.svg';
import { logUserActivity } from '../../../../services/UsersApi';
import { logger } from '../../../../utils/logger';
import upArrow from '../../../../assets/up-arrow.svg';
import { useSelector } from 'react-redux';

//import Markdown from "markdown-to-jsx";
//import { BlockMath, InlineMath } from "react-katex";

//import MarkdownWithMath from "../MarkdownWithMath";
//import { use } from "react";

const AIContent = ({ ai_content_data, boxId, notebookId, setAIContent, topicId, subtopicId }) => {
	const { firstName, userId } = useSelector((state) => state.userDetails);
	const [userInput, setUserInput] = useState('');
	const [pendingPrompt, setPendingPrompt] = useState(null);
	const [isLoading, setLoading] = useState(false);
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [previewUrls, setPreviewUrls] = useState({});
	const fileInputRef = useRef(null);
	const [isPreviewOpen, setIsPreviewOpen] = useState(null);
	const selectedSubTopicDetails = useSelector(
		(state) => state.selectedSubTopic.selectedSubTopicData
	);
	const selectedMainTab = useSelector((state) => state.mainTab.tab_name);
	const [conversationHistory, setConversationHistory] = useState([]);
	const contentRef = useRef(null);

	logger.log('AIContent Data inside AIContent file: ', ai_content_data);
	const handleFileSelect = (event) => {
		const files = Array.from(event.target.files);

		files.forEach((file) => {
			if (file) {
				const allowedTypes = [
					'application/pdf',
					'text/plain',
					'application/msword',
					'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
					'image/jpeg',
					'image/png',
					'image/gif',
					'image/webp',
				];
				const maxSize = 5 * 1024 * 1024; // 5MB

				if (!allowedTypes.includes(file.type)) {
					alert('Please select a PDF, TXT, DOC, or image file (JPEG, PNG, GIF, WEBP)');
					return;
				}

				if (file.size > maxSize) {
					alert('File size should be less than 5MB');
					return;
				}

				// Generate unique ID for the file
				const fileId = Date.now() + Math.random().toString(36).substr(2, 9);

				setSelectedFiles((prev) => [...prev, { id: fileId, file }]);

				// Create preview URL for images
				if (file.type.startsWith('image/')) {
					const url = URL.createObjectURL(file);
					setPreviewUrls((prev) => ({ ...prev, [fileId]: url }));
				}
			}
		});
	};

	const clearFile = (fileId) => {
		setSelectedFiles((prev) => prev.filter((f) => f.id !== fileId));
		if (previewUrls[fileId]) {
			URL.revokeObjectURL(previewUrls[fileId]);
			setPreviewUrls((prev) => {
				const newUrls = { ...prev };
				delete newUrls[fileId];
				return newUrls;
			});
		}
	};

	// Cleanup preview URLs when component unmounts
	/*useEffect(() => {
    return () => {
      Object.values(previewUrls).forEach((url) => URL.revokeObjectURL(url));
    };
  }, []);*/

	/*useEffect(() => {
    ai_content_data.forEach((ai_content) => {
      if (ai_content.ATTACHMENTS) {
        ai_content.ATTACHMENTS.forEach((file) => {
          logger.log("File URL:", file.url);
        });
      }
    });
  }, [ai_content_data]);*/
	/*useEffect(() => {
    if (window.MathJax) {
      window.MathJax.typesetPromise();
    }
  }, [ai_content_data]);*/

	useEffect(() => {
		if (conversationHistory.length === 0 && ai_content_data.length > 0) {
			const initialHistory = ai_content_data
				.map((ai_content) => ({
					role: 'user',
					content: ai_content.AI_PROMPT,
				}))
				.concat(
					ai_content_data.map((ai_content) => ({
						role: 'assistant',
						content: ai_content.AI_RESPONSE,
					}))
				);
			setConversationHistory(initialHistory);
		}
	}, [ai_content_data, conversationHistory.length]);

	const handleSendMessage = async () => {
		const startTime = new Date().toISOString();
		let prompt = userInput.trim();
		let topicName = selectedSubTopicDetails.topicName;
		let subtopicName = selectedSubTopicDetails.subtopicName;
		const formData = new FormData();
		if (!prompt) return;

		//if (!validatePrompt(prompt)) return;

		try {
			setLoading(true);
			setUserInput('');
			setPendingPrompt(prompt);

			try {
				//constuct conversation history
				let history = conversationHistory.map((entry) => ({
					role: entry.role,
					content: entry.content,
				}));
				history.push({ role: 'user', content: prompt });
				logger.log('Conversation History: ', history);

				formData.append('prompt', prompt);
				formData.append('section', selectedMainTab);
				formData.append('topicId', topicId);
				formData.append('subtopicId', subtopicId);
				formData.append('notebookId', notebookId);
				formData.append('topicName', topicName);
				formData.append('subtopicName', subtopicName);
				formData.append('userId', userId);
				formData.append('conversation', JSON.stringify(history));
			} catch (err) {
				logger.log('Error while constructing conversation history ', err);
			}

			// Add files
			selectedFiles.forEach(({ file }, index) => {
				formData.append(`document${index}`, file);
			});

			// Get AI response with S3 URLs
			const aiResponse = await getAIContentData(formData);
			if (!aiResponse.success) {
				throw new Error(aiResponse.error || 'Failed to get AI response');
			}
			console.log('Response for AI Generated Content: ', aiResponse.data.data);

			const latestIdResponse = await getLatestAIContentId();
			if (!latestIdResponse.data?.latestId) {
				throw new Error('Failed to get latest AI content ID');
			}

			const newAIContentId = latestIdResponse.data.latestId;
			logger.log('Response from AI >>>>> ', aiResponse.data.data);
			const extractedFileContents = aiResponse.data.data.fileContents || [];
			logger.log('Extracted file contents: ', extractedFileContents);
			const formattedResponse = (aiResponse.data.data || '')
				.replace(/\n{2,}/g, '<br/><br/>') // Preserve paragraph breaks
				.replace(/\n/g, '<br/>') // Convert single newlines
				.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>') // Bold text
				.replace(/###\s*/g, '') // Remove all ### without affecting text
				.replace(/\\\\\(/g, '\\(') // Unescape \\( to \(
				.replace(/\\\\\)/g, '\\)') // Unescape \\) to \)
				.replace(/\\\\\[/g, '\\[') // Unescape \\[ to \[
				.replace(/\\\\\]/g, '\\]'); // Unescape \\] to \]

			// Handle inline math with proper delimiters
			//.replace(/\\\((.*?)\\\)/g, `\($1 \))`) // Preserve inline math
			//.replace(/\\\[(.*?)\\\]/g, `\[$1 \])`); // Preserve display math

			logger.log('Formatted Response=======> ', formattedResponse);

			//store conversation hisotry including file content
			setConversationHistory((prev) => [
				...prev,
				{ role: 'user', content: prompt },
				...extractedFileContents.map((file) => ({
					role: 'system',
					content: `File "${file.filename} content:\n ${file.content}" `,
				})),
				{ role: 'assistant', content: formattedResponse },
			]);
			logger.log('Conversation History state: ', conversationHistory);

			const newEntry = {
				AI_CONTENT_ID: String(newAIContentId),
				AI_PROMPT: prompt,
				AI_RESPONSE: formattedResponse,
				BOX_ID: boxId,
				NOTEBOOK_ID: String(notebookId),
				TOPIC_ID: topicId,
				SUBTOPIC_ID: subtopicId,
				HAS_ATTACHMENT: selectedFiles.length > 0,
				ATTACHMENTS: aiResponse.data.files, // Store S3 URLs and file details
				CREATED_AT: new Date().toLocaleString(), // Store date in human-readable format
			};

			// Save to DynamoDB
			const saveResponse = await saveAIContent(newEntry);
			if (!saveResponse.success) {
				throw new Error('Failed to save AI content');
			}

			// Update local state
			setAIContent((prevData) => [...prevData, newEntry]);
			setPendingPrompt(null);
			setSelectedFiles([]); // Clear selected files

			// (after setConversationHistory and saveAIContent)

			const endTime = new Date().toISOString();
			const durationSec = Math.round((new Date(endTime) - new Date(startTime)) / 1000);

			await logUserActivity({
				userId,
				eventType: 'KC_AI_CONTENT',
				startTime,
				endTime,
				durationSec,
				topicId,
				subtopicId,
				// notebookId,
			});
		} catch (error) {
			logger.log('Error handling message:', error);
		} finally {
			setLoading(false);
		}
	};

	const validatePrompt = (prompt) => {
		let topicName = selectedSubTopicDetails.topicName;
		let subtopicName = selectedSubTopicDetails.subtopicName;
		let topicKeywords = [];
		let subtopicKeywords = [];
		topicKeywords.push(topicName);

		subtopicKeywords.push(subtopicName);
		if (!subtopicName || !topicName) {
			return false;
		}

		const topicMatch = topicKeywords.some((keyword) =>
			prompt.toLowerCase().includes(keyword.toLowerCase())
		);

		const subtopicMatch = subtopicKeywords.some((keyword) =>
			prompt.toLowerCase().includes(keyword.toLowerCase())
		);

		if (!topicMatch || !subtopicMatch) {
			alert(
				'Your prompt does not align with the selected topic or subtopic. Please refine it.'
			);
			return false;
		}

		return true;
	};

	const handleFilePaste = (event) => {
		const items = event.clipboardData.items;
		const files = [];

		for (let i = 0; i < items.length; i++) {
			if (items[i].kind === 'file') {
				const file = items[i].getAsFile();
				if (file && file.type.startsWith('image/')) {
					const defaultName = `pasted_image_${Date.now()}.${file.type.split('/')[1]}`;
					const renamedFile = new File([file], defaultName, {
						type: file.type,
					});
					files.push(renamedFile);
				} else {
					files.push(file);
				}
			}
		}

		if (files.length > 0) {
			handleFileSelect({ target: { files } });
		}
	};

	useEffect(() => {
		const messageBox = document.querySelector(
			`.message-box[data-box-id="${boxId}"] .message-ai`
		);
		messageBox.addEventListener('paste', handleFilePaste);

		return () => {
			messageBox.removeEventListener('paste', handleFilePaste);
		};
	}, [boxId]);

	const sortedAIContentData = [...ai_content_data].sort((a, b) => {
		const dateA = new Date(a.CREATED_AT);
		const dateB = new Date(b.CREATED_AT);
		return dateA - dateB;
	});
	logger.log('Sorted AI Content Data: ', sortedAIContentData);
	logger.log('Conversation history before rendering: ', conversationHistory);

	useEffect(() => {
		const timeout = setTimeout(() => {
			if (window.MathJax && ai_content_data.length > 0 && contentRef.current) {
				window.MathJax.typesetPromise([contentRef.current])
					.then(() => console.log('MathJax typeset completed'))
					.catch((err) => console.error('MathJax typesetting failed:', err));
			}
		}, 100);

		return () => clearTimeout(timeout);
	}, [ai_content_data]);

	return (
		<MathJaxContext
			config={{
				tex: {
					inlineMath: [['\\(', '\\)']],
					displayMath: [['\\[', '\\]']],
				},
			}}
			version={3}
			renderMode="post" // <-- important!
		>
			<div>
				{ai_content_data.length === 0 && (
					<div className="ai-content-header">
						<h1 className="ai-content-title">Hi there, {firstName}</h1>
						<h2 className="ai-content-subtitle">What would you like to learn?</h2>
					</div>
				)}
				<div className="ai-content-messages" ref={contentRef}>
					{sortedAIContentData.length > 0 &&
						sortedAIContentData.map((ai_content, index) => (
							<div key={index} className="ai-content-text" style={{ width: '100%' }}>
								<br />

								{ai_content.HAS_ATTACHMENT && ai_content.ATTACHMENTS.length > 0 && (
									<div className="ai-content-attached-files">
										{ai_content.ATTACHMENTS.map((row) => (
											<div key={row.id} className="ai-content-file-info">
												<div className="file-details">
													<img
														src={fileIcon}
														alt="File"
														className="file-icon"
													/>
													<span>{row.name}</span>
												</div>
											</div>
										))}
									</div>
								)}
								<div style={{ width: '100%', alignItems: 'end' }}>
									<h3
										style={{
											marginRight: '1.5rem',
											backgroundColor: '#EBEBEB',
											width: 'fit-content',
											padding: '1.5rem',
											borderRadius: '1rem',
										}}
									>
										{ai_content.AI_PROMPT}
									</h3>
								</div>
								{ai_content.AI_RESPONSE &&
									typeof ai_content.AI_RESPONSE === 'string' &&
									ai_content.AI_RESPONSE.trim().length > 0 && (
										// <MathJax>
										//   <div
										//     className="math-content"
										//     dangerouslySetInnerHTML={{
										//       __html: ai_content.AI_RESPONSE,
										//     }}
										//   />
										// </MathJax>
										<div
											style={{
												textAlign: 'start',
												marginTop: '1.5rem',
												marginRight: '1.5rem',
											}}
											className="math-content"
											dangerouslySetInnerHTML={{
												__html: ai_content.AI_RESPONSE,
											}}
										/>
									)}
							</div>
						))}
					{pendingPrompt && (
						<div className="ai-content-text" style={{ width: '100%' }}>
							<br />
							<div style={{ width: '100%', alignItems: 'end' }}>
								<h3
									style={{
										marginRight: '1.5rem',
										backgroundColor: '#EBEBEB',
										width: 'fit-content',
										padding: '1.5rem',
										borderRadius: '1rem',
									}}
								>
									{pendingPrompt}
								</h3>
							</div>
							{isLoading && <ChatGPTLoader />}
						</div>
					)}
				</div>

				<div className="message-box" data-box-id={boxId}>
					<input
						className="message-ai"
						placeholder="Message AI"
						value={userInput}
						onChange={(e) => setUserInput(e.target.value)}
						onKeyDown={(e) => e.key === 'Enter' && handleSendMessage()}
					/>
					<div className="attach-wrapper">
						<div className="left-icons">
							<input
								type="file"
								ref={fileInputRef}
								onChange={handleFileSelect}
								style={{ display: 'none' }}
								accept=".pdf,.txt,.doc,.docx,.jpg,.jpeg,.png,.gif,.webp"
								multiple
							/>
							<span
								className="attach-icon"
								onClick={() => fileInputRef.current.click()}
							>
								<img src={fileAttachmant} alt="File Attachment Icon" />
								{selectedFiles.length > 0 && (
									<span className="file-badge">{selectedFiles.length}</span>
								)}
							</span>
						</div>
						<span className="send-icon" onClick={handleSendMessage}>
							<img src={upArrow} alt="Send Icon" />
						</span>
					</div>
					{selectedFiles.length > 0 && (
						<div className="selected-files">
							{selectedFiles.map(({ id, file }) => (
								<div key={id} className="file-info">
									<div className="file-details">
										<img src={fileIcon} alt="File" className="file-icon" />
										<span>{file.name}</span>
									</div>
									<button onClick={() => clearFile(id)} className="remove-file">
										×
									</button>
								</div>
							))}
						</div>
					)}
				</div>
				{/* Image Preview Modal */}
				{isPreviewOpen && previewUrls[isPreviewOpen] && (
					<ImagePreviewModal
						imageUrl={previewUrls[isPreviewOpen]}
						onClose={() => setIsPreviewOpen(null)}
					/>
				)}
			</div>
		</MathJaxContext>
	);
};

export default AIContent;
